import React from 'react';
import { Trans } from 'react-i18next';
import Typography from '../../sharedComponents/Typography/Typography';
import styles from './unsupported-currency-notice.module.scss';
import { CurrencyUnit } from '../../utils/types/Currency/Currency.types';
import useErrorRecord from '../../hooks/useErrorRecord';
import { PayoutAccount } from '../../utils/types/Entity';

type Props = {
  policyCurrency: CurrencyUnit;
  payoutAccount: PayoutAccount;
};

const UnsupportedCurrencyNotice: React.FunctionComponent<Props> = ({
  policyCurrency,
  payoutAccount,
}) => {
  useErrorRecord(
    `Policy does not match Default Account Currency.  Policy Currency: ${policyCurrency}, Account Currency: ${payoutAccount?.currency}, Payout Account ID: ${payoutAccount?.id}`,
  );

  return (
    <>
      <Typography variant="body-2" className={styles.defaultNotSupportedText}>
        <Trans
          i18nKey="sunshine.label.default_account_currency_warning"
          values={{ currency: policyCurrency?.toUpperCase() }}
          components={{ strong: <strong /> }}
        ></Trans>
      </Typography>
    </>
  );
};

export default UnsupportedCurrencyNotice;
